import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import React, { useMemo } from 'react';
import toast from 'react-hot-toast';
import { CartItem, Order } from '../product/context/ProductContext.tsx';
import { getOptionLabel } from '../product/ProductType.ts';

interface ExportOrdersButtonProps {
  filteredOrders: Order[];
}

const ExportOrdersButton: React.FC<ExportOrdersButtonProps> = ({
  filteredOrders,
}) => {
  const noOrders = useMemo(() => filteredOrders.length === 0, [filteredOrders]);

  const formatNumber = (num: number | string) => {
    const clean = Math.round(Number(num)).toString();
    return clean.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const handleExport = () => {
    if (noOrders) {
      toast.error('No hay órdenes para exportar.');
      return;
    }

    try {
      const doc = new jsPDF();
      let yOffset = 10;

      filteredOrders.forEach((order: Order, index) => {
        let startHour = 'N/A';
        let endHour = 'N/A';
        if (order.timeSlot) {
          const [start, end] = order.timeSlot.split('-');
          startHour = start || 'N/A';
          endHour = end || 'N/A';
        }

        const totalOrden = order.totalPrice;

        console.log('Total Orden:', totalOrden);

        // 🟢 Columna izquierda
        doc.setFontSize(13);
        doc.setTextColor(20);
        doc.text(`Orden #${order.id}`, 14, yOffset);
        doc.setFontSize(11);
        yOffset += 6;
        doc.text(`Cliente: ${order.user?.name || 'N/A'}`, 14, yOffset);
        yOffset += 6;
        doc.text(
          `Fecha: ${new Date(order.date).toLocaleDateString()}`,
          14,
          yOffset
        );
        yOffset += 6;
        doc.text(`Horario entrega: ${startHour} - ${endHour}`, 14, yOffset);

        // 🟢 Columna derecha
        const rightColX = 110;
        let rightYOffset = yOffset - 12;
        doc.text(
          `Dirección: ${order.user?.address || 'N/A'}, ${
            order.user?.city || ''
          }`,
          rightColX,
          rightYOffset
        );
        rightYOffset += 6;
        doc.text(
          `Medio de pago: ${order.paymentMethod || 'N/A'}`,
          rightColX,
          rightYOffset
        );
        rightYOffset += 6;
        doc.text(
          `Total: $${formatNumber(totalOrden)}`,
          rightColX,
          rightYOffset
        );

        yOffset = Math.max(yOffset + 10, rightYOffset + 10);

        // 🟢 Tabla de productos
        const productRows = order.cart.items.map((item: CartItem) => {
          console.log(`🧾 Item: ${item.product.name}`);
          console.log(`🔸 partialPrice (crudo):`, item.partialPrice);
          console.log(`🔸 totalPrice (crudo):`, item.totalPrice);
          console.log(`🔸 quantity:`, item.quantity);
          console.log('---------------------------');

          return [
            item.product.name,
            getOptionLabel(item.purchaseOption),
            item.quantity,
            `$${formatNumber(item.partialPrice)}`,
            `$${formatNumber(item.totalPrice)}`,
          ];
        });

        autoTable(doc, {
          startY: yOffset,
          head: [
            ['Producto', 'Opción', 'Cantidad', 'Precio Unitario', 'Total'],
          ],
          body: productRows,
          styles: { fontSize: 10 },
          headStyles: { fillColor: [240, 240, 240], textColor: 20 },
          margin: { top: 10, left: 14, right: 14 },
          columnStyles: {
            0: { cellWidth: 50 }, // Producto
            1: { cellWidth: 25 }, // Opción
            2: { cellWidth: 20 }, // Cantidad
            3: { cellWidth: 30 }, // Precio Unitario
            4: { cellWidth: 30 }, // Total
          },
          didDrawPage: (data) => {
            if (data.cursor) {
              yOffset = data.cursor.y + 2;
            }
          },
        });

        yOffset += 15;
      });

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(
        2,
        '0'
      )}-${String(today.getMonth() + 1).padStart(
        2,
        '0'
      )}-${today.getFullYear()}`;

      const filename = `ordenes-${formattedDate}.pdf`;
      doc.save(filename);
      toast.success('PDF exportado correctamente.');
    } catch (error) {
      toast.error('Error al generar el PDF');
      console.error(error);
    }
  };

  return (
    <button
      className="primary-button margin-top-21"
      onClick={handleExport}
      disabled={noOrders}
    >
      Exportar órdenes
    </button>
  );
};

export default ExportOrdersButton;
